;(function () {
  const createIcon = (direction) => {
    const arrowIcon = document.createElement('i')
    arrowIcon.className = `cmp-tabs__arrow-icon ri-arrow-${direction}-line`
    arrowIcon.setAttribute('aria-hidden', 'true')
    return arrowIcon
  }

  function createArrowButton(direction, ariaLabel) {
    const btn = document.createElement('button')
    btn.type = 'button'
    btn.className = 'cmp-tabs__arrow cmp-tabs__arrow--' + direction
    btn.setAttribute('aria-label', ariaLabel)
    btn.style.display = 'none'
    btn.appendChild(createIcon(direction))
    return btn
  }

  function initTabs(container) {
    const tablist = container.querySelector('.cmp-tabs__tablist')

    if (!tablist) {
      return
    }

    const arrowLeft = createArrowButton('left', 'Scroll tabs to start')
    const arrowRight = createArrowButton('right', 'Scroll tabs to end')

    container.appendChild(arrowLeft)
    container.appendChild(arrowRight)

    function updateArrows() {
      const scrollLeft = tablist.scrollLeft
      const overflows = tablist.scrollWidth > tablist.clientWidth
      const maxScrollLeft = tablist.scrollWidth - tablist.clientWidth

      arrowLeft.style.display = overflows && scrollLeft > 0 ? '' : 'none'
      arrowRight.style.display = overflows && scrollLeft < maxScrollLeft ? '' : 'none'
    }

    arrowLeft.addEventListener('click', function () {
      tablist.scrollBy({ left: -tablist.clientWidth, behavior: 'smooth' })
    })

    arrowRight.addEventListener('click', function () {
      tablist.scrollBy({ left: tablist.clientWidth, behavior: 'smooth' })
    })

    tablist.addEventListener('scroll', updateArrows, { passive: true })

    const resizeObserver = new ResizeObserver(updateArrows)
    resizeObserver.observe(container)

    updateArrows()
  }

  function onDocumentReady() {
    const tabContainers = document.querySelectorAll('.cmp-tabs')
    tabContainers.forEach(function (container) {
      initTabs(container)
    })
  }

  if (document.readyState !== 'loading') {
    onDocumentReady()
  } else {
    document.addEventListener('DOMContentLoaded', onDocumentReady)
  }
})()
